import { Environment } from './Environment';

import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';
import { IEnvironment } from '../interfaces/IEnvironment';
import { IOrgAssetPermissionFolder } from '../interfaces/OrgAssets/IOrgAssetPermissionFolder';
import { IOrgAssetsInfo } from '../interfaces/IOrgAssetsInfo';

export default class UploaderService {

  public static getOrgAssets(environment: IEnvironment, token: string, tenant: string): Promise<IOrgAssetsInfo[]> {
    return new Promise<any[]>((resolve, reject): void => {
      if (environment && tenant && token) {
        const url = Environment.getEnvironmentForOrgAssetsAPI(environment) + `/${tenant}/mapping`;
        new FetchProxy(url, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            reject();
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      } else {
        reject();
      }
    });
  }

  public static getOrgAssetsWithUploadPermissions(environment: IEnvironment, token: string, tenant: string): Promise<IOrgAssetPermissionFolder[]> {
    return new Promise<IOrgAssetPermissionFolder[]>((resolve): void => {
      if (environment && tenant && token) {
        const url = Environment.getEnvironmentForMainAPI(environment) + `/api/permissions/${tenant}/orgassets/upload`;
        new FetchProxy(url, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }

  public static getOrgAssetsWithReadPermissions(environment: IEnvironment, token: string, tenant: string): Promise<IOrgAssetPermissionFolder[]> {
    return new Promise<IOrgAssetPermissionFolder[]>((resolve): void => {
      if (environment && tenant && token) {
        const url = Environment.getEnvironmentForMainAPI(environment) + `/api/permissions/${tenant}/orgassets/read`;
        new FetchProxy(url, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }

  public static getFilesByListGuid(environment: IEnvironment, token: string, tenant: string, siteUrl: string, libraryGuid: string): Promise<any[]> {
    return new Promise<any[]>((resolve: (result: any[]) => void): void => {
      if (environment && tenant && token) {
        const url = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}/${siteUrl.replace("/", "")}/guid/${libraryGuid}/files`;
        new FetchProxy(url, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }

  public static getFilesByListServerRelativeUrl(environment: IEnvironment, token: string, tenant: string, site: string, serverRelativeUrl: string, sortOrder?: string): Promise<any[]> {
    return new Promise<any[]>((resolve: (result: any[]) => void): void => {
      if (environment && tenant && token && site && serverRelativeUrl) {
        const url = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}/${site.replace("/", "")}/files?serverRelativeUrl=${serverRelativeUrl}&sortOrder=${sortOrder ?? ""}`;
        new FetchProxy(url, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }

}